import { AgFormat } from "../../common/utils/agGridFormat";

export function GetHeaders() {
  return [
    {
      field: "fpvtradenegoentityregion",
      headerName: "FPV trading - nego entity region",
      width: 50,
    },
    { headerName: "Trading PC mnemo", field: "pcmnemo", width: 50 },
    {
      field: "pclabel",
      headerName: "Trading PC label",
      width: 50,
    },
    {
      cellClass: "text-right",
      comparator: AgFormat.AgNumberComparator,
      field: "retentionrate",
      filter: "number",
      filterParams: { comparator: AgFormat.AgNumberComparator },
      headerName: "Retention rate",
      valueGetter: AgFormat.AgGridFormatPercentageWithSeparator,
      width: 20,
    },
    {
      cellClass: "text-right",
      comparator: AgFormat.AgNumberComparator,
      field: "percentage",
      filter: "number",
      filterParams: { comparator: AgFormat.AgNumberComparator },
      headerName: "SC",
      valueGetter: AgFormat.AgGridFormatPercentageWithSeparator,
      width: 15,
    },
  ];
}
